const tableRow = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.MuiTableRow-hover': {
        'td, th': {
          transition: 'border-color 100ms ease-out',
        },
        '&:hover': {
          backgroundColor: theme.alpha(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        },
      },
    }),
  },
}

export default tableRow
